import React from 'react';
import { Heart, MapPin, Phone, Mail, Clock, Leaf } from 'lucide-react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-tr from-blue-900 via-gray-900 to-orange-600 text-white">
      {/* Main Footer */}
      <div className="container-custom py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/img/LogoSolnascente.png" 
                alt="Sol Nascente Hortaliças" 
                className="h-12 w-auto"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
              <div>
                <h3 className="text-xl font-bold text-orange-400">Sol Nascente</h3>
                <p className="text-blue-300">Hortaliças</p>
              </div>
            </div>
            <p className="text-blue-200 leading-relaxed mb-6 max-w-md">
              Há mais de 70 anos cultivando qualidade, frescor e tradição familiar na 
              distribuição de hortaliças. Sua confiança é nossa maior conquista.
            </p>
            <div className="flex items-center gap-2 text-orange-300">
              <Heart className="text-orange-400" size={20} />
              <span>Feito com amor pela família Sol Nascente</span>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-blue-400">Contato</h4>
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <Phone className="text-orange-400" size={18} />
                <span className="text-orange-200">(15) 3241-5413</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="text-blue-400" size={18} />
                <span className="text-blue-200 text-xs break-all">comercial@solnascentehortalicas.com.br</span>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="text-blue-400 mt-1" size={18} />
                <span className="text-blue-200">
                  Ibiúna - SP<br />
                  Distribuição para toda Grande São Paulo
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="text-orange-400 mt-1" size={18} />
                <span className="text-orange-200">
                  Segunda a Sábado: 8h às 18h<br />
                  (com possibilidade de plantão)
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-orange-400">Links Rápidos</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-orange-400 transition-colors duration-200"
                >
                  Início
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-orange-400 transition-colors duration-200"
                >
                  Sobre Nós
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-orange-400 transition-colors duration-200"
                >
                  Produtos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-orange-400 transition-colors duration-200"
                >
                  Serviços
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('locations')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-orange-400 transition-colors duration-200"
                >
                  Lojas
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-blue-200 hover:text-orange-400 transition-colors duration-200"
                >
                  Contato
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-blue-900">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <div className="flex items-center gap-2 text-blue-200">
              <Leaf className="text-orange-400" size={18} />
              <span>© {currentYear} Sol Nascente Hortaliças. Todos os direitos reservados.</span>
            </div>
            <div className="flex items-center gap-6">
              <a 
                href="https://wa.me/551532415413" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-300 hover:text-orange-400 transition-colors duration-200"
              >
                WhatsApp
              </a>
              <a 
                href="mailto:comercial@solnascentehortalicas.com.br"
                className="text-blue-300 hover:text-blue-400 transition-colors duration-200"
              >
                Email
              </a>
              <button 
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="text-blue-300 hover:text-orange-400 transition-colors duration-200"
              >
                Voltar ao Topo
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
